var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/formLabel.scss';
import React, { useId } from 'react';
import { Foreground } from '@front/sharedcomponents/Styles';
import { Label } from '../Label/Label';
import { TextState } from '../Label/TextState';
export const FormLabel = (_a) => {
    var { children, label, labelColor = Foreground.Secondary, disabled = false } = _a, restProps = __rest(_a, ["children", "label", "labelColor", "disabled"]);
    const formElementId = useId();
    const childWithId = React.cloneElement(children, Object.assign({ id: formElementId }, children.props));
    return (_jsxs("label", Object.assign({ className: `form-control-label${disabled ? ' disabled' : ''}`, htmlFor: formElementId }, restProps, { children: [childWithId, _jsx(Label, { color: labelColor, state: disabled ? TextState.Disabled : TextState.Default, children: label })] })));
};
